<template>
  <div>
    <button class="d-none" data-target="#EditEventDetailModal" data-toggle="modal" ref="openEditEventDetailModal"
      v-on:click="resetForms">
    </button>

    <div class="modal fade" id="EditEventDetailModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog product-cart-modal" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-left-wrapper">
              <div class="left-content">
                <div class="modal-header">
                  <span class="modal-title" id="exampleModalLabel">Update Event</span>
                  <button type="button" class="close-modal d-block d-md-none" data-dismiss="modal" aria-label="Close"
                    ref="closeEventModal">
                    <img src="../../../../assets/Svg/close.svg" alt="" />
                  </button>
                </div>
                <div class="d-flex align-items-start flex-wrap flex-lg-nowrap" style="gap: 16px; padding-top: 16px;">
                  <div class="event-image">
                    <div class="team-image-create event-image-create">
                      <img v-if="
                        this.eventAvatar.length == 0 &&
                        this.eventFinalAvatar == ''
                      " src="../../../../assets/Svg/event-upload.svg" alt="event_image" class="default-image" />
                      <img v-else-if="this.eventAvatar.length == 0"
                        :src="this.$eventAvatarStorageURL + singleEvent.avatar" alt="" />
                      <clipper-basic v-else-if="this.eventAvatar.length > 0" :src="this.rawData" preview="preview"
                        :border="4" :outline="0" :corner="false" :ratio="1" :wrap-ratio="1" :init-width="50"
                        :init-height="50" ref="clipper"></clipper-basic>
                      <div class="edit-icon-wrapper" @click="openinput()">
                        <img src="../../../../assets/Svg/team/team-options/edit-2.svg" alt="edit" />
                      </div>
                    </div>
                    <!-- <div class="preview-image">
                      <div v-if="this.eventAvatar.length > 0">
                        <clipper-preview name="preview"></clipper-preview>
                      </div>
                      <div v-else-if="this.eventAvatar.length == 0" class="no-image-wrapper">
                        <div slot="placeholder">No image</div>
                      </div>
                    </div> -->
                  </div>
                  <div class="event-detail">
                    <div class="container-fluid no-pdd">
                      <div class="row">

                        <div class="col-12 mt-3 mt-lg-0">
                          <div class="form-group">
                            <input type="text" class="form-control" id="EditEventNameAsso" v-model="eventName"
                              @input="errorNull" trim required maxlength="100" :class="{
                                'is-invalid': $v.eventName.$error,
                                'is-valid': !$v.eventName.$invalid,
                              }" autocomplete="off" spellcheck="false" />
                            <span v-if="!$v.eventName.required" class="invalid-tooltip">
                              Event name is required
                            </span>
                            <span class="placeholder">Event Name</span>
                          </div>
                        </div>

                        <div class="col-12 col-md-6">
                          <div class="form-group" :class="{ filled: startDate }">
                            <date-picker :open="open" @close="open = false" :editable="false" :clearable="false"
                              @click.native="open = true" v-model="startDate" valueType="format" format="MMM DD, YYYY"
                              @change="checkdate" :class="{
                                'is-invalid': $v.startDate.$error,
                                'is-valid': !$v.startDate.$invalid,
                              }">
                              <i slot="icon-calendar" class="cursor-pointer">
                                <img src="../../../../assets/Svg/calendar.svg" />
                              </i>
                            </date-picker>
                            <span v-if="!$v.startDate.required" class="invalid-tooltip">
                              Start date is required
                            </span>
                            <span class="placeholder">Start Date</span>
                          </div>
                        </div>

                        <div class="col-12 col-lg-6 pl-lg-0 startTime">
                          <div class="form-group" :class="{ filled: startTime }">
                            <div class="input-group time" id="startTimeCheck" data-target-input="nearest">
                              <vue-timepicker id="startTime" class="time-input" required="required" v-model="startTime"
                                v-on:change="checkTime" :disabled="allDay" hide-clear-button
                                format="hh:mm A" data-target-input="nearest" @open="dropdownState = 'opened'"
                                @close="dropdownState = 'closed'" :class="{
                                  'is-invalid': $v.startTime.$error,
                                  'is-valid': !$v.startTime.$invalid,
                                }">
                                <template v-slot:icon>
                                  <img src="../../../../assets/Svg/clock.svg" />
                                </template>
                              </vue-timepicker>
                              <span v-if="!$v.startTime.required" class="invalid-tooltip">
                                Start time is required
                              </span>
                            </div>
                            <span class="placeholder">Start Time</span>
                          </div>
                        </div>

                        <div class="col-12 col-lg-6 mt-3 mt-lg-0">
                          <div class="form-group" :class="{ filled: endDate }">
                            <span class="event-error" v-if="endDateErrorGreater != ''">
                              End Date should be greater than start date
                            </span>
                            <date-picker :open="openEnd" @close="openEnd = false" :editable="false" :clearable="false"
                              @click.native="openEnd = true" v-model="endDate" valueType="format" format="MMM DD, YYYY"
                              @change="checkdate" :class="{
                                'is-invalid': $v.endDate.$error,
                                'is-valid': !$v.endDate.$invalid,
                              }">
                              <i slot="icon-calendar" class="cursor-pointer">
                                <img src="../../../../assets/Svg/calendar.svg" />
                              </i>
                            </date-picker>
                            <span v-if="!$v.endDate.required" class="invalid-tooltip">
                              End date is required
                            </span>
                            <span class="placeholder">End Date</span>
                          </div>
                        </div>

                        <div class="col-12 col-lg-6 pl-lg-0 endTime">
                          <div class="form-group" :class="{ filled: endTime }">
                            <div class="input-group time" id="endTimeCheck" data-target-input="nearest">
                              <vue-timepicker id="endTime" class="time-input" required="required" v-model="endTime"
                                v-on:change="checkTime" :disabled="allDay" hide-clear-button
                                format="hh:mm A" data-target-input="nearest" @open="dropdownState = 'opened'"
                                @close="dropdownState = 'closed'" :class="{
                                  'is-invalid': $v.endTime.$error,
                                  'is-valid': !$v.endTime.$invalid,
                                }">
                                <template v-slot:icon>
                                  <img src="../../../../assets/Svg/clock.svg" />
                                </template>
                              </vue-timepicker>
                              <span v-if="!$v.endTime.required" class="invalid-tooltip">
                                End time is required
                              </span>
                            </div>
                            <span class="placeholder">End Time</span>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-3 mt-lg-0">

                        <div class="col-sm-12 col-lg-6 mt-3 mb-0 my-lg-0 order-2 order-lg-1">
                          <div class="form-group">
                            <select class="form-control" id="eventType" v-model="eventType" @change="errorNull" :class="{
                              filled: eventType,
                              'is-invalid': $v.eventType.$error,
                              'is-valid': !$v.eventType.$invalid,
                            }">
                              <option v-for="option in filteredEventTypeOptions" :value="option.value"
                                :key="option.value">
                                {{ option.label }}
                              </option>
                            </select>
                            <span v-if="!$v.eventType.required" class="invalid-tooltip">
                              Event type is required
                            </span>
                            <span class="placeholder">Event Type</span>
                          </div>
                        </div>

                        <div
                          class="col-12 col-lg-6 pl-lg-0 d-flex align-items-center justify-content-between order-1 order-lg-2"
                          style="margin-top: -16px">
                          <label for="allDayEvent" class="pr-lg-2 mb-0">All Day</label>
                          <toggle-button class="toogle m-0" v-model="allDay" :value="false" :sync="true" :width="34"
                            ref="toggleBtn" />
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12 col-lg-6 my-3 my-lg-0">
                          <div class="form-group">
                            <select class="form-control" id="eventType" v-model="time_zone" @change="onTimeZoneChange"
                              :class="{
                                filled: time_zone,
                                'is-invalid': $v.time_zone.$error,
                                'is-valid': !$v.time_zone.$invalid,
                              }">
                              <option :value="country.gmt + ' ' + country.name" v-for="country in timeZoneList"
                                :key="country.name">
                                {{ country.gmt }} {{ country.name }}
                              </option>
                            </select>
                            <span v-if="!$v.time_zone.required" class="invalid-tooltip">
                              Time zone is required
                            </span>
                            <span class="placeholder">Timezone</span>
                          </div>
                        </div>

                        <div class="col-12 col-lg-6 pl-lg-0">
                          <div class="form-group" :class="{ filled: entryFee }">
                            <input type="text" class="form-control" id="entryFee" v-model="entryFee"
                              @input="validateNumber" @keyup="errorNull" required :class="{
                                'is-invalid': $v.entryFee.$error,
                                'is-valid': !$v.entryFee.$invalid,
                              }" />
                            <span v-if="!$v.entryFee.required" class="invalid-tooltip">
                              Entry Fee is required
                            </span>
                            <span class="placeholder">Entry Fee</span>
                            <span class="custom-icon-wrap">$</span>
                          </div>
                        </div>

                        <div class="col-12 col-lg-6">
                          <div class="form-group" :class="{ filled: events?.association }">
                            <input type="text" class="form-control" id="directorName" v-model="events.association"
                              required disabled />
                            <span class="placeholder">Association</span>
                          </div>
                        </div>

                        <div class="col-12 col-lg-6 pl-lg-0">
                          <div class="form-group" :class="{ filled: deadlineDate }">
                            <date-picker :open="openDeadline" @close="openDeadline = false" :editable="false"
                              :clearable="false" @click.native="openDeadline = true" v-model="deadlineDate"
                               valueType="date" format="MMM DD, YYYY" :class="{
                                'is-invalid': $v.deadlineDate.$error,
                                'is-valid': !$v.deadlineDate.$invalid,
                              }">
                              <i slot="icon-calendar" class="cursor-pointer">
                                <img src="../../../../assets/Svg/calendar.svg" />
                              </i>
                            </date-picker>
                            <span v-if="!$v.deadlineDate.required" class="invalid-tooltip">
                              Entry deadline is required
                            </span>
                            <span class="placeholder">Entry Deadline</span>
                          </div>
                        </div>

                        <!-- <div class="col-12">
                          <div class="form-group" :class="{ filled: poolPlay }">
                            <select class="form-control" id="poolPlay" v-model="poolPlay" @change="errorNull">
                              <option v-for="option in poolPlayOptions" :value="option.value" :key="option.value">
                                {{ option.label }}
                              </option>
                            </select>
                            <span class="placeholder">Pool Play</span>
                          </div>
                        </div> -->

                        <input type="file" class="d-none" id="vue-file-edit" v-on:change="addEventAvatar"
                          accept="image/png, image/jpeg" />

                      </div>

                      <input type="file" class="d-none" id="vue-file-new" v-on:change="addEventAvatar"
                        accept="image/png, image/jpeg" />

                    </div>
                  </div>
                </div>

                <ul class="nav nav-tabs event-popup-tabs" id="myTab" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link active" id="format-tab" data-toggle="tab" href="#format" role="tab">Tournament
                      Details</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="refund-tab" data-toggle="tab" href="#refund" role="tab">Refund
                      Policy</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="reminder-tab" data-toggle="tab" href="#reminderTab" role="tab">Reminder</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" id="note-tab" data-toggle="tab" href="#noteTab" role="tab">Event Notes</a>
                  </li>
                </ul>

                <div class="tab-content mt-3" id="myTabContent">
                  <div class="tab-pane fade" id="refund" role="tabpanel">
                    <div class="form-group">
                      <textarea type="text" class="form-control" :class="{ filled: refundPolicy }" id="refundPolicy"
                        rows="6" v-model="refundPolicy" @keyup="errorNull" required></textarea>
                      <span class="placeholder">Refund Policy</span>
                    </div>
                  </div>

                  <div class="tab-pane fade show active" id="format" role="tabpanel">
                    <div class="row no-gutters">
                      
                      <div class="col-12 col-lg-6 col-xl-4">
                        <div class="row no-gutters">
                          <h6>Director Information</h6>
                          <div class="col-12">
                            <div class="form-group">
                              <input type="text" class="form-control" id="directorName" v-model="directorName"
                                @keyup="errorNull" required />
                              <span class="placeholder">Director Name</span>
                            </div>

                            <div class="form-group">
                              <div class="d-lg-flex">
                                <!-- Code Select -->
                                <div class="form-group w-50 pr-lg-2 phone-no"
                                  :class="{ filled: phonedetails.mob_code }">
                                  <b-form-select v-model="phonedetails.mob_code" :options="codeList"
                                    v-on:keyup="errorNull">
                                    <template #first></template>
                                  </b-form-select>
                                  <span class="placeholder">Country Code</span>
                                </div>
                                <!-- Phone Number Input -->
                                <div class="form-group flex-grow-1" :class="{ filled: phonedetails.mob }">
                                  <input id="edit_mob_phone_asso" class="form-control" v-model.trim="phonedetails.mob"
                                    spellcheck="false" autocomplete="off" v-phone-mask :class="{
                                      'is-invalid': validationStatus($v.phonedetails.mob),
                                    }" @keydown.backspace="handleDelete" trim required type="text"
                                    v-on:keyup="errorNull" />
                                  <div v-if="!$v.phonedetails.mob.minLength" class="invalid-tooltip">
                                    Minimum length should be 10.
                                  </div>
                                  <span class="placeholder">Number</span>
                                </div>
                              </div>
                            </div>

                            <div class="form-group">
                              <input type="email" class="form-control" :class="{ filled: directorEmail }"
                                id="directorEmailEdit" v-model="directorEmail" @keyup="errorNull" required />
                              <span class="placeholder">Email</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-lg-6 col-xl-4 pl-lg-3">
                        <div class="row no-gutters">
                          <h6>Format</h6>
                          <div class="col-12">
                            <div class="form-group">
                              <select class="form-control" id="gameGuarantee" v-model="gameGuarantee"
                                @change="errorNull" :class="{
                                  filled: gameGuarantee,
                                  'is-invalid': $v.gameGuarantee.$error,
                                  'is-valid': !$v.gameGuarantee.$invalid,
                                }">
                                <option v-for="option in gameGuaranteeOptions" :value="option.value"
                                  :key="option.value">
                                  {{ option.label }}
                                </option>
                              </select>
                              <span v-if="!$v.gameGuarantee.required" class="invalid-tooltip">
                                Pool play guaranteed is required
                              </span>
                              <span class="placeholder">Pool play guaranteed</span>
                            </div>

                            <div class="form-group">
                              <select class="form-control" id="brackeFormat" v-model="brackeFormat" @change="errorNull"
                                :class="{
                                  filled: brackeFormat,
                                  'is-invalid': $v.brackeFormat.$error,
                                  'is-valid': !$v.brackeFormat.$invalid,
                                }">
                                <option v-for="option in bracketFormats" :value="option.id" :key="option">
                                  {{ option.bracket_name }}
                                </option>
                              </select>
                              <span v-if="!$v.brackeFormat.required" class="invalid-tooltip">
                                Bracket format is required
                              </span>
                              <span class="placeholder">Bracket Format</span>
                            </div>

                            <div class="form-group" :class="{ filled: slotTime }">
                              <input type="number" maxlength="2" class="form-control" id="slotTime" v-model="slotTime"
                                required />
                              <span class="placeholder">Timeslot (minutes)</span>
                            </div>

                          </div>
                        </div>
                      </div>
                      
                      <div class="col-12 col-lg-6 col-xl-4 pl-xl-3">
                        <div class="row no-gutters">
                          <h6>Time Limits (minutes)</h6>
                          <div class="col-12">
                            <div class="form-group" :class="{ filled: poolPlayTime }">
                              <input type="text" class="form-control" id="poolPlayTime"
                                v-model="poolPlayTime" required />
                              <span class="placeholder">Pool Play</span>
                            </div>

                            <div class="form-group" :class="{ filled: bracketTime }">
                              <input type="text" class="form-control" id="bracketTime"
                                v-model="bracketTime" required />
                              <span class="placeholder">Bracket</span>
                            </div>

                            <div class="form-group" :class="{ filled: championshipTime }">
                              <input type="text" class="form-control" id="championshipTime"
                                v-model="championshipTime" required />
                              <span class="placeholder">Championship</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <textarea type="text" class="form-control" :class="{ filled: tournamentFormat }"
                        id="tournamentFormat" rows="6" v-model="tournamentFormat" @keyup="errorNull"
                        required></textarea>
                      <span class="placeholder">Additional Notes</span>
                    </div>
                  </div>

                  <div class="tab-pane fade" id="reminderTab" role="tabpanel">
                    <div class="form-group">
                      <textarea type="text" class="form-control" :class="{ filled: reminder }" id="reminder" rows="6"
                        v-model="reminder" @keyup="errorNull" required></textarea>
                      <span class="placeholder">Reminder</span>
                    </div>
                  </div>

                  <div class="tab-pane fade" id="noteTab" role="tabpanel">
                    <div class="form-group">
                      <textarea type="text" class="form-control" :class="{ filled: note }" id="note" rows="6"
                        v-model="note" @keyup="errorNull" required></textarea>
                      <span class="placeholder">Notes</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="right-content container-fluid">
                <div>
                  <button type="button" class="close-modal d-none d-md-block w-100 text-right pb-2" data-dismiss="modal"
                    aria-label="Close" ref="closeEventModal">
                    <img src="../../../../assets/Svg/close.svg" alt="" />
                  </button>
                  <ul class="event-menu-list">
                    <li class="list-item" v-bind:class="[openTabEvent == 1 ? 'active' : '']" @click="InPerson">
                      <img v-if="openTabEvent == 1" src="../../../../assets/images/inperson-blue.png" />
                      <img v-else src="../../../../assets/images/inperson-grey.png" />
                      InPerson
                    </li>
                    <li class="list-item" v-bind:class="[openTabEvent == 2 ? 'active' : '']" @click="onlineContent">
                      <img v-if="openTabEvent == 2" src="../../../../assets/images/online-blue.png" />
                      <img v-else src="../../../../assets/images/online-grey.png" />
                      Online
                    </li>
                  </ul>
                  <div class="row no-gutters" v-if="openTabEvent == 1">
                    <div class="col-12 p-0">
                      <div class="form-group">
                        <gmap-autocomplete :value="location" placeholder="Enter an address, zipcode, or location"
                          @place_changed="setPlace" ref="autocompleteRef">
                        </gmap-autocomplete>
                      </div>
                    </div>
                    <div class="col-12">
                      <google-map :center="marker.position" :zoom="18" map-style-id="roadmap" :options="mapOptions"
                        style="width: 100%; height: 40vmin; margin-bottom: 20px;" ref="mapRef" id="map"
                        @click="handleMapClick">
                        <google-maps-marker :position="marker.position" :clickable="true" :draggable="true"
                          @drag="handleThrottledMarkerDrag" @click="panToMarker"></google-maps-marker>
                      </google-map>
                      <div class="form-group" :class="{ filled: street }">
                        <input type="text" class="form-control" id="street" v-model="street" @keyup="errorNull" required
                          :class="{
                            'is-invalid': $v.street.$error,
                            'is-valid': !$v.street.$invalid,
                          }" />
                        <span v-if="!$v.street.required" class="invalid-tooltip">
                          Street address is required
                        </span>
                        <span class="placeholder">Street Address</span>
                      </div>
                    </div>
                  </div>
                  <div class="row no-gutters" v-if="openTabEvent == 1">
                    <div class="col-12 col-md-4 pr-md-2">
                      <div class="form-group" :class="{ filled: city }">
                        <input type="text" class="form-control" id="city" v-model="city" @keyup="errorNull" required
                          :class="{
                            'is-invalid': $v.city.$error,
                            'is-valid': !$v.city.$invalid,
                          }" />
                        <span v-if="!$v.city.required" class="invalid-tooltip">
                          City is required
                        </span>
                        <span class="placeholder">City</span>
                      </div>
                    </div>
                    <div class="col-12 col-md-4 px-md-0">
                      <div class="form-group" :class="{ filled: state }">
                        <input type="text" class="form-control" id="state" v-model="state" @keyup="errorNull" required
                          :class="{
                            'is-invalid': $v.state.$error,
                            'is-valid': !$v.state.$invalid,
                          }" />
                        <span v-if="!$v.state.required" class="invalid-tooltip">
                          State is required
                        </span>
                        <span class="placeholder">State</span>
                      </div>
                    </div>
                    <div class="col-12 col-md-4 pl-md-2">
                      <div class="form-group" :class="{ filled: zipCode }">
                        <input type="number" class="form-control" id="zipCode" v-model="zipCode" @keyup="errorNull"
                          required :class="{
                            'is-invalid': $v.zipCode.$error,
                            'is-valid': !$v.zipCode.$invalid,
                          }" />
                        <span v-if="!$v.zipCode.required" class="invalid-tooltip">
                          Zipcode is required
                        </span>
                        <span class="placeholder">Zip Code</span>
                      </div>
                    </div>
                  </div>
                  <div class="row no-gutters" v-if="openTabEvent == 2">
                    <div class="col-12 p-0">
                      <div class="form-group" :class="{ filled: medium }">
                        <select class="form-control" id="medium" v-model="medium" @change="errorNull()" :class="{
                          'is-invalid': $v.medium.$error,
                          'is-valid': !$v.medium.$invalid,
                        }">
                          <option v-for="option in mediumOptions" :key="option.id" :value="option.id">
                            {{ option.name }}
                          </option>
                        </select>
                        <span v-if="!$v.medium.required" class="invalid-tooltip">
                          Medium is required
                        </span>
                        <span class="placeholder">Medium</span>
                      </div>
                    </div>
                    <div class="col-12 p-0">
                      <div class="form-group" :class="{ filled: Url }">
                        <input type="text" class="form-control" id="Url" v-model="Url" @keyup="$v.Url.$touch()"
                          @input="$v.Url.$touch()" required :class="{
                            'is-invalid': $v.Url.$error,
                            'is-valid': !$v.Url.$invalid && $v.Url.$model
                          }" />
                        <span v-if="Url && !$v.Url.urlValidator" class="invalid-tooltip">
                          URL is invalid
                        </span>
                        <span v-if="!$v.Url.required" class="invalid-tooltip">
                          URL is required
                        </span>
                        <span class="placeholder">URL</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="event-btns-wrapper">
                  <button class="btn btn-danger w-50" @click="deleteEvent()">
                    <img src="../../../../assets/Svg/trash.svg" />
                    <span>Delete</span>
                  </button>
                  <button type="button" class="btn btn-primary w-50" v-on:click="editEvent(0)"
                    :disabled="isLoadingArray[0]">
                    <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
                    <span v-else>
                      <img src="../../../../assets/Svg/save.svg" />
                      Update
                    </span>
                  </button>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import VueTimepicker from "vue2-timepicker";
import _ from 'lodash';
import {
  required,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
// import * as firestoreService from "../../../../database/firestore";
import $ from "jquery";
// import Multiselect from "vue-multiselect";
//let countries = require("../../../../assets/js/country");
let eventType = require("../../../../assets/js/eventType");

let usTime = require("../../../../assets/js/usTimeZone");
import { clipperBasic } from "vuejs-clipper";

const urlValidator = (value) => {
  if (!value) return true; // Let 'required' handle empty fields

  const regx = new RegExp(
    "^" +
    "(?:(?:https?|http)://)?" +
    "(?:\\S+(?::\\S*)?@)?" +
    "(?:" +
    "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
    "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
    "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
    "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
    "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
    "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
    "|" +
    "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
    "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
    "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" +
    ")" +
    "(?::\\d{2,5})?" +
    "(?:/\\S*)?" +
    "$", "i"
  );

  return regx.test(value);
};

export default {
  components: {
    // Multiselect,
    clipperBasic,
    // clipperPreview,
    VueTimepicker,
  },
  validations() {
    return this.checkedOnline
      ? {
        eventName: { required, maxLength: maxLength(100) },
        startDate: { required },
        endDate: { required },
        startTime: { required },
        endTime: { required },
        eventType: { required },
        time_zone: { required },
        entryFee: { required },
        deadlineDate: { required },
        gameGuarantee: { required },
        brackeFormat: { required },
        street: {},
        city: {},
        state: {},
        zipCode: {},
        medium: { required },
        Url: { required, urlValidator },
        phonedetails: {
          mob: { minLength: minLength(10) },
        },
      }
      : {
        eventName: { required, maxLength: maxLength(100) },
        startDate: { required },
        endDate: { required },
        startTime: { required },
        endTime: { required },
        eventType: { required },
        time_zone: { required },
        entryFee: { required },
        deadlineDate: { required },
        street: { required },
        city: { required },
        state: { required },
        zipCode: { required },
        gameGuarantee: { required },
        brackeFormat: { required },
        medium: {},
        Url: {},
        phonedetails: {
          mob: { minLength: minLength(10) },
        },
      };
  },
  data() {
    return {
      singleEvent: [],
      open: false,
      openDeadline: false,
      deadlineDate: "",
      openEnd: false,
      eventURL: this.$eventAvatarStorageURL,
      userName: localStorage.getItem("userName"),
      isDisabledEvent: true,
      showLoaderEvent: 0,
      eventName: null,
      eventType: "",
      entryFee: "",
      gameGuarantee: "",
      poolPlay: "",
      brackeFormat: "",
      refundPolicy: "",
      tournamentFormat: "",
      eventTypeOptions: eventType,
      association: "",
      codeList: [
        { value: "+92", text: "Pak (+92)" },
        { value: "+1", text: "USA (+1)" },
      ],
      gameGuaranteeOptions: [
        { value: "1", label: "1" },
        { value: "2", label: "2" },
        { value: "3", label: "3" },
        { value: "4", label: "4" },
        { value: "5", label: "5" }
      ],
      poolPlayOptions: [
        { value: "None", label: "None" },
        { value: "1", label: "1" },
        { value: "2", label: "2" },
        { value: "3", label: "3" },
        { value: "Round Robin", label: "Round Robin" }
      ],
      divisionTypeOptions: [
        { value: "Single", label: "Single Ellimination" },
        { value: "Double", label: "Double Ellimination" },
        { value: "Triple", label: "Triple Ellimination" },
        { value: "3 Game Guarantee", label: "3 Game Guarantee" },
        { value: "Round Robin", label: "Round Robin" },
      ],
      bracketFormats: [],
      phonedetails: {
        mob: "",
        mob_code: "+1",
      },
      reminder: "",
      location: "",
      exactEndTime: "11:00 AM",
      exactStartTime: "10:00 AM",
      exactStartDate: "",
      exactEndDate: "",
      startDate: "",
      directorEmail: "",
      directorPhone: "",
      directorName: "",
      endDate: "",
      startTime: "10:00 AM",
      endTime: "11:00 AM",
      startTime24Hour: "",
      endTime24Hour: "",
      city: "",
      state: "",
      zipCode: "",
      street: "",
      country: "",
      lan: "",
      long: "",
      note: "",
      allDay: false,
      rawData: "",
      openTabEvent: 1,
      isLoadingArray: [],
      eventAvatar: [],
      eventFinalAvatar: "",
      options: [],
      mediumOptions: [],
      marker: { position: { lat: 10, lng: 10 } },
      center: { lat: 10, lng: 10 },
      mapOptions: {
        disableDefaultUI: false,
        gestureHandling: 'cooperative', // allows zooming only with Ctrl + wheel on desktop
        disableDoubleClickZoom: true, // disables zoom on double-click
      },
      startDateError: "",
      endDateError: "",
      endDateErrorGreater: "",
      exactStartDateformat: "",
      savedLocationData: null,
      savedEventData: null,
      exactEndDateformat: "",
      timeError: "",
      onlineStatus: false,
      checkedOnline: false,
      Url: "",
      medium: "",
      isValid: true,
      associationsAdd: [],
      isLoading: false,
      assoChange: 0,
      timeZoneList: usTime,
      time_zone: "",
      deviceTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      Storage_URL: this.$googleMapApi,
      latLng: {},
      userInteracted: false,
      slotTime: 90,
      poolPlayTime: '',
      bracketTime: '',
      championshipTime: ''
    };
  },

  watch: {
    bracketFormats(newVal) {
      if (newVal && newVal.length > 0) {
        this.mapBracketFormat();
      }
    },
    time_zone() {
      if (this.userInteracted) {
        return;
      }
      this.setDefaultTimeZone();
    },
    singleEvent: {
      handler() {
        this.checkOpenTabEvent();
      },
      deep: true
    },
    city(newValue) {
      this.city = newValue;
      this.errorNull();
    },
    state(newValue) {
      this.state = newValue;
      this.errorNull();
    },
    street(newValue) {
      this.street = newValue;
      this.errorNull();
    },
    zipCode(newValue) {
      this.zipCode = newValue;
      this.errorNull();
    },
  },
  computed: {
    formattedDeviceTimeZone() {
      const gmtOffset = this.getDynamicGmtOffset(this.deviceTimeZone);
      const normalizedTimeZone = this.getNormalizedDeviceTimeZone(this.deviceTimeZone);
      return gmtOffset ? `${gmtOffset} ${normalizedTimeZone}` : this.deviceTimeZone;
    },
    filteredEventTypeOptions() {
      return this.eventTypeOptions.filter(option => option.status === 1);
    },
  },
  methods: {
    handleDelete(event) {
      const input = event.target;
      const cursorPos = input.selectionStart;
      const value = this.phonedetails.mob;
      const formattingChars = ['(', ')', ' ', '-'];

      if (event.key === 'Backspace' && cursorPos > 0) {
        const charBeforeCursor = value[cursorPos - 1];
        if (formattingChars.includes(charBeforeCursor)) {
          // If the character before cursor is a formatting char, prevent default
          event.preventDefault();
          // Move cursor back by one and try again
          this.$nextTick(() => {
            input.setSelectionRange(cursorPos - 1, cursorPos - 1);
          });
        }
      } else if (event.key === 'Delete' && cursorPos < value.length) {
        const charAtCursor = value[cursorPos];
        if (formattingChars.includes(charAtCursor)) {
          // If the character at cursor is a formatting char, prevent default
          event.preventDefault();
          this.$nextTick(() => {
            input.setSelectionRange(cursorPos + 1, cursorPos + 1);
          });
        }
      }
    },
    onTimeZoneChange() {
      this.userInteracted = true;
      this.errorNull();
    },
    // Normalize device time zone to a more familiar name if needed
    getNormalizedDeviceTimeZone(deviceTimeZone) {
      if (deviceTimeZone === "Pacific/Honolulu") {
        return "Hawaii Time";
      }
      else if (deviceTimeZone === "America/Los_Angeles") {
        return "Pacific Time";
      }
      else if (deviceTimeZone === "America/Anchorage") {
        return "Alaska Time";
      }
      else if (deviceTimeZone === "America/Denver") {
        return "Mountain Time";
      }
      else if (deviceTimeZone === "America/Chicago") {
        return "Central Time";
      }
      else if (deviceTimeZone === "America/New_York") {
        return "Eastern Time";
      }
      return deviceTimeZone;
    },
    //   findTimeZoneMatch(timezone) {
    //   return this.timeZoneList.some(
    //     country => timezone === (country.gmt + ' ' + country.name)
    //   );
    // },
    getDynamicGmtOffset() {
      const date = new Date();
      const utcOffset = date.getTimezoneOffset(); // Offset in minutes from UTC
      const hoursOffset = Math.floor(Math.abs(utcOffset) / 60);
      const minutesOffset = Math.abs(utcOffset) % 60;

      // Determine the sign for the offset
      const sign = utcOffset < 0 ? '+' : '-';

      // Format the GMT offset
      return `(UTC${sign}${String(hoursOffset).padStart(2, '0')}:${String(minutesOffset).padStart(2, '0')})`;
    },
    setDefaultTimeZone() {
      const match = this.timeZoneList.find(
        (country) => `${country.gmt} ${country.name}` === this.formattedDeviceTimeZone
      );
      if (this.singleEvent.time_zone !== null) {
        this.time_zone = this.singleEvent.time_zone;
      }
      else if (match) {
        this.$nextTick(() => {
          this.time_zone = `${match.gmt} ${match.name}`;
        });
      } else {
        this.time_zone = ""; // Shows "Time Zone" if no match is found
      }
    },
    // handleClickStart(evt) {
    //   if (evt.target.tagName !== "INPUT") {
    //     this.open = true;
    //   }
    // },
    // handleClickEnd(evt) {
    //   if (evt.target.tagName !== "INPUT") {
    //     this.openEnd = true;
    //   }
    // },

    onlineContent() {
      if (!this.onlineStatus) {
        this.savedLocationData = {
          city: this.city,
          state: this.state,
          zipCode: this.zipCode,
          street: this.street,
        };

      }
      // Save medium and Url data
      this.savedEventData = {
        medium: this.medium,
        Url: this.Url
      };
      this.$v.medium.$reset();
      this.$v.Url.$reset();
      this.$root.$emit("openTabTeamEvent", 2, 0);
      this.city = "";
      this.state = "";
      this.zipCode = "";
      this.street = "";
      this.checkTab(2);
    },
    InPerson() {
      if (this.savedLocationData) {
        this.city = this.savedLocationData.city;
        this.state = this.savedLocationData.state;
        this.zipCode = this.savedLocationData.zipCode;
        this.street = this.savedLocationData.street;
      }
      // Restore medium and Url data
      if (this.savedEventData) {
        this.medium = this.savedEventData.medium;
        this.Url = this.savedEventData.Url;
      }
      this.$v.street.$reset();
      this.$v.city.$reset();
      this.$v.state.$reset();
      this.$v.zipCode.$reset();
      this.$root.$emit("openTabTeamEvent", 1, 0);
      if (this.medium == "" && this.Url == "") {
        this.isDisabledEvent = true;
      } else {
        this.isDisabledEvent = false;
      }
      this.checkTab(1);
    },

    checkTab(check) {
      if (check == 1) {
        this.onlineStatus = false;
      } else {
        this.onlineStatus = true;
      }
      if (this.onlineStatus == true) {
        this.checkedOnline = true;
      } else {
        this.checkedOnline = false;
        // this.Url = "";
      }
    },
    checkOpenTabEvent() {
      if (this.singleEvent && this.singleEvent.medium_id !== null && this.singleEvent.medium_id !== 0) {
        this.openTabEvent = 2;
      } else {
        this.openTabEvent = 1;
      }
    },
    // handleClickDeadline(evt) {
    //   if (evt.target.tagName !== "INPUT") {
    //     this.openDeadline = true;
    //   }
    // },
    async deleteEvent() {
      try {
        const confirm = await this.$confirm(
          "About to remove this event from the team. Continue?",
          "Delete Event."
        );

        if (!confirm) return;

        // Ensure singleEvent is defined
        if (!this.singleEvent || !this.singleEvent.id) {

          return;
        }

        var formData = new FormData();
        formData.append("event_id", this.singleEvent.id);

        const response = await axios.post(process.env.VUE_APP_API_URL + "associationEvent/delete", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        // Check if the response contains an error message
        if (response.data.statusCode == 404) {
          this.$alert(response.data.message, "Error");

        }

        // Firestore update is commented out as requested
        // await firestoreService.updateRoom(this.selectedRoomTeam.roomId, {
        //   eventCount: this.selectedRoomTeam.eventCount - 1,
        //   // lastUpdated: new Date(),
        // });

        // Event emissions are commented out as requested
        // this.$root.$emit("showEventList");
        // this.$root.$emit("fetchEvents");
        // this.$root.$emit("ChatSettings", 0);
        // this.$root.$emit("showEventDetailPageBack");
        if (response.data.statusCode == 200) {
          this.$alert("Event Deleted Successfully");

          // Extract association GUID from the response
          const associationGuid = response.data.data.association_guid;

          // Redirect to Association Events page
          if (associationGuid) {
            this.$router.push({
              name: "AssociationEvents",
              params: { associationGuid }
            });

          }
        }

        this.$root.$emit("fetchAssociationEvents");
        var elem = this.$refs.closeEventModal;
        if (elem) {
          this.editEventOption = false;
          elem.click();
        }

        this.showLoaderEvent = 0;
        this.assoChange = 0;
      } catch (error) {


        // Display alert with error message
        this.$alert(`Error in deleteEvent method: ${error.response ? error.response.data.message : error.message}`, "Error");
      }
    },

    resetForms: function () {
      this.getMedium();
      this.getBracketFormat();
      this.isDisabledEvent = true;
      this.showLoaderEvent = 0;
      this.event_id = "";
      this.eventName = "";
      this.eventType = "";
      this.association = "";
      this.location = "";
      this.exactEndTime = "11:00 AM";
      this.exactStartTime = "10:00 AM";
      this.exactStartDate = "";
      this.exactEndDate = "";
      this.startDate = "";
      this.endDate = "";
      this.startTime = "10:00";
      this.endTime = "11:00";
      this.city = "";
      this.state = "";
      this.zipCode = "";
      this.street = "";
      this.lan = "";
      this.long = "";
      this.note = "";
      this.allDay = false;
      this.rawData = "";
      this.eventAvatar = [];
      this.eventFinalAvatar = "";
      (this.time_zone = ""), (this.startDateError = "");
      this.endDateError = "";
      this.endDateErrorGreater = "";
      this.timeError = "";

      this.exactStartDateformat = "";
      this.exactEndDateformat = "";
      (this.medium = ""), (this.Url = "");
      this.fetchdata();
    },


    fetchdata() {
      this.$v.$reset();
      this.eventName = this.singleEvent.eventName;
      this.eventType = this.singleEvent.eventType;
      this.association = this.singleEvent;
      this.location =
        this.singleEvent.location == "null" ? "" : this.singleEvent.location;
      this.city = this.singleEvent.city == "null" ? "" : this.singleEvent.city;
      this.note = this.singleEvent.note == "null" ? "" : this.singleEvent.note;
      this.state = this.singleEvent.state;
      this.zipCode = this.singleEvent.zipCode;
      this.street =
        this.singleEvent.address == "null" ? "" : this.singleEvent.address;

      this.exactStartTime = this.singleEvent.exactStartTime ? this.singleEvent.exactStartTime : "10:00 AM";
      this.exactEndTime = this.singleEvent.exactEndTime ? this.singleEvent.exactEndTime : "11:00 AM";

      this.startTime = this.singleEvent.exactStartTime ? this.singleEvent.exactStartTime : "10:00 AM";
      this.endTime = this.singleEvent.exactEndTime ? this.singleEvent.exactEndTime : "11:00 AM";

      // this.startDate = this.singleEvent.startDateForField;
      // this.endDate = this.singleEvent.endDateForField;
      // if (this.singleEvent.time_zone == null) {
      //   this.time_zone = "";
      // } else {
      //   this.time_zone = this.singleEvent.time_zone;
      // }

      //   if (this.singleEvent.time_zone == null || !this.findTimeZoneMatch(this.singleEvent.time_zone)) {
      //   this.time_zone = this.formattedDeviceTimeZone; // Set to device timezone if no match
      // } else {
      this.time_zone = this.singleEvent.time_zone;
      // }

      this.exactStartDateformat = this.singleEvent.startDate;
      this.exactEndDateformat = this.singleEvent.endDate;
      this.marker.position.lng = this.singleEvent?.lan;
      this.marker.position.lat = this.singleEvent?.long;
      this.exactStartDate = this.singleEvent.exactStartDate;
      this.exactEndDate = this.singleEvent.exactEndDate;
      this.allDay = this.singleEvent.allDay == "true" ? true : false;
      this.rawData = "";
      this.eventAvatar = [];
      this.createdAt = this.singleEvent.createdAt;
      this.createdBy = this.singleEvent.createdBy;
      this.medium = this.singleEvent.medium_id ? this.singleEvent.medium_id : "";
      this.Url = this.singleEvent.Url;
      this.phonedetails.mob = this.singleEvent.director_phone;
      this.phonedetails.mob_code = this.singleEvent.mob_code;
      this.directorName = this.singleEvent.director_name;
      this.directorEmail = this.singleEvent.director_email;
      this.refundPolicy = this.singleEvent.refund_policy;
      this.tournamentFormat = this.singleEvent.tournament_format;
      this.gameGuarantee = this.singleEvent.game_guarantee;
      this.poolPlay = this.singleEvent.pool_play;
      this.entryFee = this.singleEvent.entry_fee;
      this.slotTime = this.singleEvent.time_interval;
      this.poolPlayTime = this.singleEvent.pool_play_time;
      this.bracketTime = this.singleEvent.bracket_time;
      this.championshipTime = this.singleEvent.championship_time;
      this.deadlineDate = this.formatDateStringWithoutTimezone(this.singleEvent.entry_fee_deadline);
      this.reminder = this.singleEvent.reminder;


      if (this.singleEvent.avatar != null) {
        this.eventFinalAvatar = this.singleEvent.avatar;
        this.rawData = this.eventURL + this.eventFinalAvatar;
      }
      if (this.singleEvent?.status == 2) {
        this.checkedOnline = true;
        this.onlineStatus = true;
      } else {
        this.checkedOnline = false;
        this.onlineStatus = false;
      }
      if (this.onlineStatus == true) {
        this.openTabEvent = 2
        this.street = "";
        this.state = "";
        this.zipCode = "";
        this.city = ""
      }
      else {
        this.openTabEvent = 1
      }
      let lat = parseFloat(this.singleEvent?.lan);
      let lng = parseFloat(this.singleEvent?.long);

      if (!isNaN(lat) && !isNaN(lng)) {
        this.marker.position = { lat, lng };
      } else {
        // fallback to default location if invalid
        this.marker.position = { lat: 10, lng: 10 };
      }
      this.initializeDate();
      // this.showHideTimeDiv2();
      this.errorNull();
      this.panToMarker();
    },
    mapBracketFormat() {
      const divisionType = (this.singleEvent.division_type || '').toLowerCase();
      let match = null;

      if (!isNaN(divisionType)) {
        const divisionId = parseInt(divisionType, 10);
        match = this.bracketFormats.find((b) => b.id === divisionId);
      } else {
        match = this.bracketFormats.find((b) =>
          b.bracket_name.toLowerCase().includes(divisionType)
        );
      }

      this.brackeFormat = match ? match.id : null;
    },
    validateNumber(event) {
      let value = event.target.value;

      // Allow only digits and a single decimal point
      value = value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');

      // Split the value into parts before and after the decimal point
      const parts = value.split('.');

      // Limit the integer part to 4 digits
      if (parts[0].length > 4) {
        parts[0] = parts[0].substring(0, 4);
      }

      // Limit the decimal part to 2 digits
      if (parts[1] && parts[1].length > 2) {
        parts[1] = parts[1].substring(0, 2);
      }

      // Recombine the parts
      this.entryFee = parts.join('.');
    },

    errorNull: function () {
      if (this.checkedOnline != true) {
        if (this.allDay === false && (this.exactStartTime === "" || this.exactEndTime === "")) {
          this.checkTime();
        }
        if (
          this.eventName == "" ||
          this.exactStartDate == "" ||
          this.exactEndDate == "" ||
          this.eventType == "" ||
          this.entryFee == "" ||
          this.deadlineDate == "" ||
          this.gameGuarantee == "" ||
          this.poolPlay == "" ||
          this.brackeFormat == "" ||
          this.city == "" ||
          this.city == null ||
          this.street == "" ||
          this.street == null ||
          this.state == "" ||
          this.state == null ||
          this.zipCode == null ||
          this.zipCode == "" ||
          this.timeError != ""
        ) {
          this.isDisabledEvent = true;
        } else {
          this.isDisabledEvent = false;
        }
      }
      if (this.checkedOnline == true) {
        // Call checkTime if allDay is false and exactStartTime or exactEndTime is empty
        if (this.allDay === false && (this.exactStartTime === "" || this.exactEndTime === "")) {
          this.checkTime();
        }
        if (
          this.medium == "" ||
          this.medium == null ||
          this.Url == "" ||
          this.Url == null ||
          this.isValid == false ||
          this.eventName == "" ||
          this.eventType == "" ||
          // this.association == "" ||
          this.timeError != "" ||
          this.startDate == "" ||
          this.endDate == "" ||
          this.entryFee == "" ||
          this.deadlineDate == "" ||
          this.gameGuarantee == "" ||
          this.poolPlay == "" ||
          this.brackeFormat == "" ||
          this.endDateErrorGreater != ""
          // ||
          // this.startTime == "" ||
          // this.endTime == ""
          // (this.allDay == false && (this.exactStartTime == "" || this.exactEndTime == "") )
        ) {
          this.isDisabledEvent = true;
        } else {
          this.isDisabledEvent = false;
        }
      }
    },

    // checkTime: function () {
    //   if (this.startTime != "") {
    //     var timeSplit = this.startTime.split(":"),
    //       hours,
    //       minutes,
    //       meridian;
    //     hours = timeSplit[0];
    //     minutes = timeSplit[1];
    //     if (hours > 12) {
    //       meridian = "PM";
    //       hours -= 12;
    //     } else if (hours < 12) {
    //       meridian = "AM";
    //       if (hours == 0) {
    //         hours = 12;
    //       }
    //     } else {
    //       meridian = "PM";
    //     }
    //     this.exactStartTime = hours + ":" + minutes + " " + meridian;

    //   }

    //   if (this.endTime != "") {
    //     var timeSplitend = this.endTime.split(":"),
    //       hoursend,
    //       minutesend,
    //       meridianend;
    //     hoursend = timeSplitend[0];
    //     minutesend = timeSplitend[1];
    //     if (hoursend > 12) {
    //       meridianend = "PM";
    //       hoursend -= 12;
    //     } else if (hoursend < 12) {
    //       meridianend = "AM";
    //       if (hoursend == 0) {
    //         hoursend = 12;
    //       }
    //     } else {
    //       meridianend = "PM";
    //     }
    //     this.exactEndTime = hoursend + ":" + minutesend + " " + meridianend;

    //   }
    //   this.checkTimeDate();
    // },

    // Check dates
    // checkdate: function() {
    //   const month = [
    //     "Jan",
    //     "Feb",
    //     "Mar",
    //     "Apr",
    //     "May",
    //     "Jun",
    //     "July",
    //     "Aug",
    //     "Sep",
    //     "Oct",
    //     "Nov",
    //     "Dec",
    //   ];

    //   // Start Date
    //   if (this.startDate.length == 10) {
    //     const startDateArray = this.formatDateForDB(this.startDate).split("-");
    //     var startMonth = startDateArray[1];
    //     var startDay = startDateArray[2];
    //     var startYear = startDateArray[0];

    //     var varDate = startMonth + "-" + startDay + "-" + startYear;
    //     var startDateConvert = new Date(varDate);
    //     this.exactStartDateformat = startDateConvert;
    //     this.exactStartDate =
    //       month[startMonth - 1] + " " + startDay + ", " + startYear;
    //   }

    //   // End Date-----
    //   if (this.endDate.length == 10) {
    //     const endDateArray = this.formatDateForDB(this.endDate).split("-");
    //     var endMonth = endDateArray[1];
    //     var endDay = endDateArray[2];
    //     var endYear = endDateArray[0];

    //     var varDatee = endMonth + "-" + endDay + "-" + endYear;
    //     var endDateConvert = new Date(varDatee);
    //     if (endDateConvert < startDateConvert) {
    //       this.endDateError = "";
    //       this.endDateErrorGreater = "on";
    //       this.exactEndDate = "";
    //       this.isDisabledEvent = true;
    //     } else {
    //       this.exactEndDateformat = endDateConvert;
    //       this.endDateError = "";
    //       this.endDateErrorGreater = "";
    //       this.exactEndDate =
    //         month[endMonth - 1] + " " + endDay + ", " + endYear;
    //     }
    //   }

    //   this.checkTimeDate();
    // },

    checkTime: function () {
      if (this.startTime != "") {
        this.exactStartTime = this.startTime;
        this.startTime24Hour = this.convertTo24Hour(this.startTime); // from 24h to 12h

      }
      if (this.endTime != "") {
        this.exactEndTime = this.endTime; // from 24h to 12h
        this.endTime24Hour = this.convertTo24Hour(this.endTime); // from 24h to 12h
      }
      this.checkTimeDate(); // keep this if you're validating date/time
    },

    convertTo24Hour(time12) {
      let [time, modifier] = time12.split(" ");
      let [hours, minutes] = time.split(":").map(Number);

      if (modifier === "PM" && hours !== 12) {
        hours += 12;
      } else if (modifier === "AM" && hours === 12) {
        hours = 0;
      }

      const paddedHours = hours.toString().padStart(2, "0");
      const paddedMinutes = minutes.toString().padStart(2, "0");

      return `${paddedHours}:${paddedMinutes}`;
    },
checkDeadline() {
      if (this.deadlineDate) {
        this.deadlineDate = this.formatDate2(this.deadlineDate);
      }
    },
     formatDate2(date) {
      const monthNames = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ];
      const d = new Date(date);
      const month = monthNames[d.getMonth()];
      const day = String(d.getDate()).padStart(2, '0');
      const year = d.getFullYear();
      console.log("dead", `${month} ${day}, ${year}`);

      return `${month} ${day}, ${year}`;
    },
    checkdate: function () {
      const month = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ];

      let startDateConvert, endDateConvert;

      // Convert Start Date
      if (this.startDate && this.startDate.length === 12) {  // Format: "Mar 21, 2025"
        const startDateArray = this.startDate.split(" ");
        let startMonth = month.indexOf(startDateArray[0]) + 1; // Convert month to number
        startMonth = startMonth < 10 ? `0${startMonth}` : startMonth; // Add leading zero
        const startDay = startDateArray[1].replace(",", ""); // Remove comma
        const startYear = startDateArray[2];

        const formattedStartDate = `${startMonth}-${startDay}-${startYear}`;
        startDateConvert = new Date(formattedStartDate);
        this.exactStartDateformat = startDateConvert;
        this.exactStartDate = `${month[startMonth - 1]} ${startDay}, ${startYear}`;
      }

      // Convert End Date
      if (this.endDate && this.endDate.length === 12) {  // Format: "Mar 21, 2025"
        const endDateArray = this.endDate.split(" ");
        let endMonth = month.indexOf(endDateArray[0]) + 1; // Convert month to number
        endMonth = endMonth < 10 ? `0${endMonth}` : endMonth; // Add leading zero
        const endDay = endDateArray[1].replace(",", ""); // Remove comma
        const endYear = endDateArray[2];

        const formattedEndDate = `${endMonth}-${endDay}-${endYear}`;
        endDateConvert = new Date(formattedEndDate);

        if (startDateConvert && endDateConvert < startDateConvert) {
          this.endDateError = "";
          this.endDateErrorGreater = "on";
          this.exactEndDate = "";
          this.isDisabledEvent = true;
        } else {
          this.exactEndDateformat = endDateConvert;
          this.endDateError = "";
          this.endDateErrorGreater = "";
          this.exactEndDate = `${month[endMonth - 1]} ${endDay}, ${endYear}`;
        }
      }

      this.checkTimeDate();
    },
    // check timeDate
    checkTimeDate: function () {
      this.startDateError = this.exactStartDate != "" ? "" : "on";
      this.endDateError = this.exactEndDate != "" ? "" : "on";

      if (this.exactStartTime != "" && this.exactStartDate != "") {
        // var today = new Date();
        // // Start Date
        // const startDateArray = this.startDate.split("-");
        // var startMonth = startDateArray[1];
        // var startDay = startDateArray[2];
        // var startYear = startDateArray[0];

        // const startTimeArray = this.exactStartTime.split(":");
        // const startTimeAMArray = startTimeArray[1].split(" ");

        // var hours = startTimeArray[0];
        // var minutes = startTimeAMArray[0];
        // var AMPM = startTimeAMArray[1];
        // if (AMPM == "PM" && hours < 12) hours = parseInt(hours) + 12;
        // if (AMPM == "AM" && hours == 12) hours = parseInt(hours) - 12;
        // var sHours = hours;
        // var sMinutes = minutes;
        // if (hours < 10) sHours = "0" + sHours;
        // if (minutes < 10) sMinutes = "0" + sMinutes;
        // var finalStartDateTime = new Date(
        //   startYear,
        //   startMonth - 1,
        //   startDay,
        //   sHours,
        //   sMinutes
        // );

        this.errorNull();
        // if (finalStartDateTime < today) {
        //   this.timeError = "on";
        //   this.isDisabledEvent = true;
        // } else {
        //   this.timeError = "";
        // }
      }

      // if (
      //   this.exactStartTime != "" &&
      //   this.exactEndTime != "" &&
      //   this.exactStartDate != "" &&
      //   this.exactEndDate != ""
      // ) {
      //   // End Date
      //   const endDateArray = this.endDate.split("-");
      //   var endMonth = endDateArray[1];
      //   var endDay = endDateArray[2];
      //   var endYear = endDateArray[0];

      //   const endTimeArray = this.exactEndTime.split(":");
      //   const endTimeAMArray = endTimeArray[1].split(" ");

      //   var endhours = endTimeArray[0];
      //   var endminutes = endTimeAMArray[0];
      //   var endAMPM = endTimeAMArray[1];
      //   if (endAMPM == "PM" && endhours < 12)
      //     endhours = parseInt(endhours) + 12;
      //   if (endAMPM == "AM" && endhours == 12)
      //     endhours = parseInt(endhours) - 12;
      //   var endsHours = endhours;
      //   var endsMinutes = endminutes;
      //   if (endhours < 10) endsHours = "0" + endsHours;
      //   if (endminutes < 10) endsMinutes = "0" + endsMinutes;
      //   var finalEndDateTime = new Date(
      //     endYear,
      //     endMonth - 1,
      //     endDay,
      //     endsHours,
      //     endsMinutes
      //   );

      //   var hoursFinal = Math.abs(finalStartDateTime - finalEndDateTime);
      //   if (hoursFinal < 1800000) {
      //     this.timeError = "on";
      //     this.isDisabledEvent = true;
      //   } else if (
      //     this.exactStartDateformat.toString() ==
      //       this.exactEndDateformat.toString() &&
      //     AMPM == "PM" &&
      //     endAMPM == "AM"
      //   ) {
      //     this.timeError = "on";
      //     this.isDisabledEvent = true;
      //   }
      //   else if (
      //     this.exactStartDateformat.toString() ==
      //       this.exactEndDateformat.toString() &&
      //     AMPM == "AM" &&
      //     endAMPM == "AM" &&
      //     (endsHours < sHours)
      //   ) {
      //     this.timeError = "on";
      //     this.isDisabledEvent = true;
      //   } else if (
      //     this.exactStartDateformat.toString() ==
      //     this.exactEndDateformat.toString() &&
      //     AMPM == "PM" &&
      //     endAMPM == "PM" &&
      //     (endsHours < sHours)
      //   ) {
      //     this.timeError = "on";
      //     this.isDisabledEvent = true;
      //   }
      //   else {
      //     if (finalStartDateTime < today) {
      //       this.timeError = "on";
      //       this.isDisabledEvent = true;
      //     } else {
      //       this.timeError = "";
      //       this.errorNull();
      //     }
      //   }
      // }
    },

    // Upload Image
    openinput: function () {
      document.getElementById("vue-file-edit").click();
    },
    setPlace(place) {
      if (!place) return;
      this.$refs.autocompleteRef.$el.classList.add("custom-dropdown-open");
      this.marker.position = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.street = place.formatted_address;
      this.location = place.formatted_address;
      const addressComponents = place.address_components;

      for (const component of addressComponents) {
        const types = component.types;
        if (types.includes("locality")) {
          this.city = component.long_name;
        } else if (types.includes("administrative_area_level_1")) {
          this.state = component.short_name;
        } else if (types.includes("postal_code")) {
          this.zipCode = component.long_name;
        }
      }
      this.panToMarker();
    },
    addEventAvatar: async function (event) {
      const fileInput = document.getElementById("vue-file-edit");
      const file = event.target.files[0];
      const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;

      if (!allowedExtensions.exec(file.name)) {
        alert("Please upload file having extensions .jpeg/.jpg/.png/.gif only.");
        fileInput.value = "";
        return false;
      }

      try {
        const resized = await this.resizeImage(file); // Resize for better performance

        this.eventAvatar.push({
          original: file,              // Optional: full-size file if needed for upload
          target: resized.blob,        // Resized blob (used for preview/crop)
          fileName: file.name,
          link: resized.url,           // Blob URL used in <img> or <clipper-basic>
        });

        this.rawData = resized.url;    // Set for clipper/cropper preview
        this.errorNull();              // Your existing method (probably state cleanup)
      } catch (err) {
        console.error("Image resize failed:", err);
      }
    },

    resizeImage(file, maxSize = 1000) {
      return new Promise((resolve, reject) => {
        const fileSizeMB = file.size / (1024 * 1024);
        const mimeType = file.type; // Keep original format (e.g., image/png)

        if (fileSizeMB <= 5) {
          const originalUrl = URL.createObjectURL(file);
          return resolve({
            blob: file,
            url: originalUrl
          });
        }

        const img = new Image();
        const reader = new FileReader();

        reader.onload = (e) => {
          img.src = e.target.result;
        };

        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ratio = Math.min(maxSize / img.width, maxSize / img.height, 1);
          canvas.width = img.width * ratio;
          canvas.height = img.height * ratio;

          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          canvas.toBlob((blob) => {
            const resizedURL = URL.createObjectURL(blob);
            resolve({
              blob: blob,
              url: resizedURL
            });
          }, mimeType, 0.9); // Keep original type (image/png, image/jpeg, etc.)
        };

        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },

    dataURItoBlob: function (dataURI) {
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(",")[0].indexOf("base64") >= 0)
        byteString = atob(dataURI.split(",")[1]);
      else byteString = unescape(dataURI.split(",")[1]);

      // separate out the mime component
      var mimeString = dataURI
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];

      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      return new Blob([ia], { type: mimeString });
    },

    // Create Event
    async editEvent(index) {
      this.$v.$touch();
      if (this.$v.$pendding || this.$v.$error) return;

      if (this.$v.$invalid) {
        return
      }
      // Add Avator to storage
      this.$set(this.isLoadingArray, index, true);
      this.isDisabledEvent = true;
      var formData = new FormData();

      if (this.eventAvatar.length > 0) {
        // this.eventAvatar.forEach((value, index) => {
        //   formData.append("avatar[" + index + "]", value.target);
        // });

        const canvas = this.$refs.clipper.clip();
        var dataURL = canvas.toDataURL("image/jpeg", 0.95);
        var blob = this.dataURItoBlob(dataURL);
        this.eventAvatar.forEach((value, index) => {
          formData.append("avatar[" + index + "]", blob);
        });
      }
      this.startTime = this.allDay == true ? "00:00" : this.startTime;
      this.exactStartTime =
        this.allDay == true ? "12:00 AM" : this.exactStartTime;

      this.endTime = this.allDay == true ? "24:00" : this.endTime;
      this.exactEndTime = this.allDay == true ? "12:00 PM" : this.exactEndTime;

      // Convert user array to string
      // const userCIDArray = [];
      // this.selectedRoomTeam.users.forEach((user) => {
      //   userCIDArray.push(user.c_id);
      // });
      // var userString = userCIDArray.toString();

      formData.append("id", this.singleEvent.id);
      formData.append("eventName", this.eventName ? this.eventName : "");
      formData.append("eventType", this.eventType);
      if (this.assoChange == 1) {
        formData.append("association", this.association.id);
      }
      formData.append("startDateForField", this.formatDateForDB(this.startDate));
      formData.append("endDateForField", this.formatDateForDB(this.endDate));
      formData.append("startDate", this.exactStartDateformat);
      // formData.append("users", userString);
      formData.append("endDate", this.exactEndDateformat);
      formData.append("startTime", this.startTime);
      formData.append("endTime", this.endTime);
      formData.append("association", this.association_id);
      formData.append("director_email", this.directorEmail ? this.directorEmail : "");
      formData.append("director_phone", this.phonedetails.mob ? this.phonedetails.mob : "");
      formData.append("mob_code", this.phonedetails.mob_code ? this.phonedetails.mob_code : "");
      formData.append("director_name", this.directorName ? this.directorName : "");
      formData.append("entry_fee", this.entryFee);
      formData.append("entry_fee_deadline", this.formatDateForDB(this.deadlineDate) ? this.formatDateForDB(this.deadlineDate) : "");
      formData.append("refund_policy", this.refundPolicy ? this.refundPolicy : "");
      formData.append("tournament_format", this.tournamentFormat ? this.tournamentFormat : "");
      formData.append("reminder", this.reminder ? this.reminder : "");
      formData.append("exactStartDate", this.exactStartDate);
      formData.append("exactEndDate", this.exactEndDate);
      formData.append("exactStartTime", this.exactStartTime);
      formData.append("exactEndTime", this.exactEndTime);
      formData.append("allDay", this.allDay);
      formData.append("note", this.note ? this.note : "");
      formData.append("time_zone", this.time_zone ? this.time_zone : "");
      formData.append("game_guarantee", this.gameGuarantee ? this.gameGuarantee : "");
      formData.append("pool_play", this.poolPlay ? this.poolPlay : "");
      formData.append("time_interval", this.slotTime ? this.slotTime : 90);
      formData.append("division_type", this.brackeFormat ? this.brackeFormat : "");
      formData.append("pool_play_time", this.poolPlayTime ? this.poolPlayTime : 65);
      formData.append("bracket_time", this.bracketTime ? this.bracketTime : 70);
      formData.append("championship_time", this.championshipTime ? this.championshipTime : 80);
      if (this.checkedOnline != true) {
        formData.append("lan", this.marker.position.lat);
        formData.append("long", this.marker.position.lng);
        formData.append("address", this.street ? this.street : "");
        formData.append("location", this.location ? this.location : "");
        formData.append("city", this.city ? this.city : "");
        formData.append("state", this.state ? this.state : "");
        formData.append("zipCode", this.zipCode ? this.zipCode : "");
        formData.append("medium_id", "");
        formData.append("Url", "");
        formData.append("online", this.onlineStatus);
      } else if (this.checkedOnline == true) {
        formData.append("medium_id", this.medium ? this.medium : "");
        formData.append("Url", this.Url ? this.Url : "");
        formData.append("location", "");
        formData.append("city", "");
        formData.append("state", "");
        formData.append("address", "");
        formData.append("zipCode", "");
        formData.append("online", this.onlineStatus);
      }

      await axios
        .post(process.env.VUE_APP_API_URL + "associationEvent/update", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.statusCode === 404) {
            this.$alert(response.data.message, "Error")
            this.$router.push({ name: "Teams" });
          }
          this.$root.$emit("fetchAssociationEvents");
          if (!window.location.href.includes('/association')) {
            this.$root.$emit("fetchEventDataOnEdit");
          }
          // firestoreService.updateRoom(this.selectedRoomTeam.roomId, {
          //   eventCount: this.selectedRoomTeam.eventCount + 1,
          //   // lastUpdated: new Date(),
          // });

          // this.$root.$emit("showEventList");
          // this.$root.$emit("fetchEvents");
          // this.$root.$emit("ChatSettings", 0);
          // this.$root.$emit("showEventDetailPageBack");

          // var currentRouteName = this.$router.currentRoute.name;

          //   if (currentRouteName === "SingleEventDetail") {
          //     this.$root.$emit("showEventPageGames")
          //   }

          var elem = this.$refs.closeEventModal;
          elem.click();
          this.$set(this.isLoadingArray, index, false);
          this.assoChange = 0;
        });
    },
    validationStatus: function (validation) {
      return typeof validation != "undefined" ? validation.$error : false;
    },
    getMedium() {
      axios.get(`${process.env.VUE_APP_API_URL}getMedium`).then((response) => {
        if (response.data.statusCode == 200) {
          this.mediumOptions = response.data.data.medium;
        } else {
          this.errorMessage = response.data.message;
        }
      });
    },
    getBracketFormat() {
      axios
        .get(`${process.env.VUE_APP_API_URL}getBracketFormats`)
        .then((response) => {
          if (response.data.statusCode == 200) {
            this.bracketFormats = response.data.data.list;
            this.mapBracketFormat(); // ✅ Only map once data is loaded
          } else {
            this.errorMessage = response.data.message;
          }
        });
    },
    asyncFind(searchQuery) {
      this.isLoading = true;
      axios
        .get(
          `${process.env.VUE_APP_API_URL}getAssociation?search=${searchQuery ? searchQuery : ""
          }`,
          this.details,
          {}
        )
        .then((response) => {
          this.associationsAdd = response.data.data.association;
          this.isLoading = false;
        });
    },
    //detects location from browser
    geolocate() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.marker.position = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        this.panToMarker();
      });
    },
    handleThrottledMarkerDrag: _.throttle(function (event) {
      this.handleMarkerDrag(event);
    }, 50),
    //sets the position of marker when dragged
    handleMarkerDrag(e) {
      window.test = this;
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      var geocoder = new window.google.maps.Geocoder();
      var latlng = this.marker.position;
      geocoder.geocode({ location: latlng }, function (results, status) {
        if (status === "OK") {
          if (results[1]) {
            for (let i = 0; i < results.length; i++) {
              // eslint-disable-next-line
              window.test.location = results[2].formatted_address;
              if (results[i]?.types[0] == "locality") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (results[i].address_components[j]?.types[0] == "locality") {
                    window.test.city = results[i].address_components[j].long_name;
                  }
                }
                // this.city = results[i].long_name;
              }
              if (
                results[i]?.types[0] == "premise" ||
                results[i]?.types[0] == "street_address" ||
                results[i]?.types[0] == "route" ||
                results[i]?.types[0] == "neighborhood"
              ) {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] == "route" ||
                    results[i].address_components[j]?.types[0] == "street_address" ||
                    results[i].address_components[j]?.types[0] == "premise"
                  ) {
                    window.test.street = results[i].address_components[j].long_name;
                  }
                }
              }
              if (results[i]?.types[0] == "administrative_area_level_1") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] ==
                    "administrative_area_level_1"
                  ) {
                    window.test.state = results[i].address_components[j].long_name;
                  }
                }
              }
              if (results[i]?.types[0] == "postal_code") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (results[i].address_components[j]?.types[0] == "postal_code") {
                    window.test.zipCode = results[i].address_components[j].long_name;
                  }
                }
              }
            }
          } else {
            window.alert("No results found");
          }
        }
      });
      this.errorNull();
    },
    getCity(addressArray) {
      let city = "";
      for (let i = 0; i < addressArray.length; i++) {
        // eslint-disable-next-line
        if (
          addressArray[i].types[0] &&
          "locality" == addressArray[i].types[0]
        ) {
          city = addressArray[i].long_name;
          return city;
        }
      }
    },
    //Moves the map view port to marker
    panToMarker() {
      if (this.marker?.position) {
        this.$refs.mapRef?.panTo(this.marker.position);
      }
    },
    //Moves the marker to click position on the map
    handleMapClick(e) {
      window.test = this;
      this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
      var geocoder = new window.google.maps.Geocoder();
      var latlng = this.marker.position;
      geocoder.geocode({ location: latlng }, function (results, status) {
        if (status === "OK") {
          if (results[0]) {
            for (let i = 0; i < results.length; i++) {
              // eslint-disable-next-line
              window.test.location = results[2].formatted_address;
              if (results[i]?.types[0] == "locality") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (results[i].address_components[j]?.types[0] == "locality") {
                    window.test.city = results[i].address_components[j].long_name;
                  }
                }
                // this.city = results[i].long_name;
              }
              if (
                results[i]?.types[0] == "premise" ||
                results[i]?.types[0] == "street_address" ||
                results[i]?.types[0] == "route"
              ) {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] == "route" ||
                    results[i].address_components[j]?.types[0] == "street_address" ||
                    results[i].address_components[j]?.types[0] == "premise"
                  ) {
                    window.test.street = results[i].address_components[j].long_name;
                  }
                }
              }
              if (results[i]?.types[0] == "administrative_area_level_1") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (
                    results[i].address_components[j]?.types[0] ==
                    "administrative_area_level_1"
                  ) {
                    window.test.state = results[i].address_components[j].long_name;
                  }
                }
              }
              if (results[i]?.types[0] == "postal_code") {
                for (let j = 0; j < results[i].address_components.length; j++) {
                  if (results[i].address_components[j]?.types[0] == "postal_code") {
                    window.test.zipCode = results[i].address_components[j].long_name;
                  }
                }
              }
            }
          } else {
            window.alert("No results found");
          }
        }
      });
      this.errorNull();
    },
    showLocation() {
      var elem = this.$refs.locationTabGet;
      elem.click();
      this.$refs.topSection.scrollTo(0, 0);
      this.geolocate();
    },
    ifOnline() {
      if (this.onlineStatus == true) {
        this.checkedOnline = true;
        this.errorNull();
      } else {
        this.checkedOnline = false;
        this.geolocate();
        this.errorNull();
      }
    },
    change(e) {
      const url = e.target.value;
      this.isURLValid(url);
      this.checkTime();
    },
    isURLValid(inputUrl) {
      var regx = new RegExp(
        "^" +
        // optional protocol identifier
        "(?:(?:https?|http)://)?" +
        // user:pass authentication
        "(?:\\S+(?::\\S*)?@)?" +
        "(?:" +
        // IP address exclusion
        // private & local networks
        "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
        "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
        "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})" +
        // IP address dotted notation octets
        // excludes loopback network 0.0.0.0
        // excludes reserved space >= 224.0.0.0
        // excludes network & broacast addresses
        // (first & last IP address of each class)
        "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
        "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
        "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
        "|" +
        // host name
        "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
        // domain name
        "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
        // TLD identifier
        "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))" +
        ")" +
        // port number
        "(?::\\d{2,5})?" +
        // resource path
        "(?:/\\S*)?" +
        "$",
        "i"
      );
      this.isValid = regx.test(inputUrl);
    },
    showHideTimeDiv() {
      if (this.allDay == true) {
        $(".startTime").hide();
        $(".endTime").hide();
        // this.exactStartTime = "";
        // this.startTime = "";
        // this.endTime = "";
        // this.exactEndTime = "";
        // this.allDay = true;
      } else {
        $(".startTime").show();
        $(".endTime").show();

        this.allDay = false;
      }
      this.errorNull();
    },
    // showHideTimeDiv2() {
    //   if (this.allDay == true) {
    //     $(".startTime").hide();
    //     $(".endTime").hide();
    //     this.exactStartTime = "";
    //     this.startTime = "";
    //     this.endTime = "";
    //     this.exactEndTime = "";
    //     // this.allDay = true;
    //   } else {
    //     $(".startTime").show();
    //     $(".endTime").show();
    //     this.allDay = false;
    //   }
    //   this.errorNull();

    // },
    initializeDate() {
      // Ensure the date is valid and set it to the date picker
      if (this.exactStartDateformat) {
        this.startDate = this.parseAndFormatDate(this.exactStartDateformat);
      }
      if (this.exactEndDateformat) {
        this.endDate = this.parseAndFormatDate(this.exactEndDateformat);
      }
      // if (this?.singleEvent?.entry_fee_deadline) {
      //   const parsedDate = new Date(this.singleEvent.entry_fee_deadline); // Convert to Date
      //   this.deadlineDate = isNaN(parsedDate.getTime())
      //     ? "Invalid Date"
      //     : this.formatDate(parsedDate); // Format properly
      // }
    },

    parseAndFormatDate(dateString) {
      if (!dateString) return "";

      let parsedDate;

      // Normalize the date string (remove timezone text like "Pakistan Standard Time")
      const cleanDateString = dateString.replace(/\sGMT.*$/, "");

      // Try parsing as a standard date string
      parsedDate = new Date(cleanDateString);

      if (isNaN(parsedDate.getTime())) {
        // Fallback: Try parsing manually
        try {
          parsedDate = new Date(Date.parse(dateString));
        } catch (e) {
          return "Invalid Date";
        }
      }

      return this.formatDate(parsedDate);
    },

    formatDate(date) {
      if (!(date instanceof Date) || isNaN(date.getTime())) return "Invalid Date";

      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      const d = new Date(date);
      const month = monthNames[d.getMonth()];
      const day = String(d.getDate()).padStart(2, '0');
      const year = d.getFullYear();

      return `${month} ${day}, ${year}`;
    },


    formatDateForDB(date) {
      if (!date) return null; // Ensure there's a valid date
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    },
    formatDateStringWithoutTimezone(dateString) {
    if (!dateString || typeof dateString !== 'string') return null;
    
    const [year, month, day] = dateString.split("-");
    
    // Safety: Ensure all parts exist
    if (!year || !month || !day) return null;
    
    // Validate the parts
    const yearNum = parseInt(year, 10);
    const monthNum = parseInt(month, 10);
    const dayNum = parseInt(day, 10);
    
    if (isNaN(yearNum) || isNaN(monthNum) || isNaN(dayNum)) return null;
    if (monthNum < 1 || monthNum > 12) return null;
    if (dayNum < 1 || dayNum > 31) return null;
    
    // Create a proper Date object (month is 0-indexed in Date constructor)
    const dateObj = new Date(yearNum, monthNum - 1, dayNum);
    
    // Validate the created date
    if (isNaN(dateObj.getTime())) return null;
    
    console.log("Formatted Date Object:", dateObj);
    return dateObj;
  }


  },
  props: {
    association_id: {
      type: [Number, String],
    },
    events: {
      type: Object
    }
  },
  mounted() {
    this.setDefaultTimeZone();
    this.geolocate();
    this.checkOpenTabEvent();
    this.asyncFind();
    //  Don't allow to select past date
    // var dtToday = new Date();
    // var month = dtToday.getMonth() + 1;
    // var day = dtToday.getDate();
    // var year = dtToday.getFullYear();

    // if(month < 10)
    //     month = '0' + month.toString();
    // if(day < 10)
    //     day = '0' + day.toString();

    // var maxDate = year + '-' + month + '-' + day;
    // $('#startDate').attr('min', maxDate);
    // $('#endDate').attr('min', maxDate);

    // -----------------------------------
    //this.geolocate();
    this.$root.$on("openTabTeamEvent", (id) => {
      this.openTabEvent = id;
    });
    this.$root.$on("updateEditEventDetailModal", (data) => {
      this.singleEvent = data;
      var elem = this.$refs.openEditEventDetailModal;
      if (elem) {
        elem.click();
      }

    });
  },
  name: "EditEventDetailModal",
};
</script>
